import React,{Component} from "react";
import { FormGroup, Col, Label, Button} from "reactstrap";
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import LoadProgressIndicator from '../../../../Assets/images/ProgressIndicator.gif';
import { Icon } from 'semantic-ui-react';
import { getAllBuildingsList, getAllFamilyTypesList,getEquipmentList,getEquipmentPropertiesList,getDatalogDefinitionsList,getDataSourceDetails } from '../../../../action/ReportManagement/ManageReports';
import { MultiSelect } from "react-multi-select-component";
import DataExportHeader from "./DataExportHeader";

const displayUnHidden = {
    display:'block'
}

const displayHidden = {
    display:'none'
}

class SelectDataSources extends Component {
    constructor(props){
        super(props);
        this.state = {
            SelectedBuildings: [],          
            SelectedFamilyTypes: [],
            SelectedEquipments: [],
            SelectedPoints: [],
            SelectedDatalogs: [],
            isToggle: false,
            redirectBack: false,
            IsBuildingLoading: true,
            IsFamilyTypeLoading: true,
            IsEquipmentLoading: false,
            IsPointLoading: false,
            IsDatalogLoading: false,
            IsPointFetching: false,
            IsDatalogFetching: false,
            PointType: 0,
            SelectedReportID:"0",
            startDate: null,
            endDate: null,
            isDateTimeChanged: false,
        }
        this.OnNext = this.OnNext.bind(this);
        this.goBack = this.goBack.bind(this);
        this.OnCancel = this.OnCancel.bind(this);
        this.handleRadioPoints = this.handleRadioPoints.bind(this);
        this.setDataToEdit = this.setDataToEdit.bind(this);
        this.setDate = this.setDate.bind(this);
    }

    async componentWillMount(){
        const buildings = this.props.GetBuildingsList();
        const familyTypes = this.props.GetAllFamilyTypesList();
        await Promise.all([buildings,familyTypes]);
        this.setState({IsBuildingLoading: false, IsFamilyTypeLoading: false});

        var SelectedReportDetails;
        SelectedReportDetails = sessionStorage.getItem("SelectedReportDetails");
        if(SelectedReportDetails !== undefined && SelectedReportDetails !== null){
           var details = JSON.parse(SelectedReportDetails);
            var SelectedReportID = details.id;
            if(SelectedReportID !== undefined && SelectedReportID !== null){
                this.setState({SelectedReportID:SelectedReportID,IsEquipmentLoading:true,IsPointLoading:true,IsDatalogLoading:true});
                const dataSource = this.props.GetDataSourceDetails(SelectedReportID);
                await Promise.all([dataSource]);
                this.setDate();
                this.setDataToEdit();
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({isDateTimeChanged: nextProps.isTimePeriodChanged});
        }
    }

    setDate(){
        var SelectedReportDetails = sessionStorage.getItem("SelectedReportDetails");
        if(SelectedReportDetails !== undefined && SelectedReportDetails !== null){
        var data = JSON.parse(SelectedReportDetails);
            if(data !== undefined && data !== null){
                var current = new Date();
                switch(data.reportPeriod){
                    case "-1D" : 
                                let yesterday = new Date(current.setDate(current.getDate() - 1));
                                let startofYesterday = new Date(yesterday.setHours(0, 0, 0, 0));
                                let endofYesterday = new Date(yesterday.setHours(23,59,59,59));
                                this.setState({startDate:startofYesterday,endDate:endofYesterday});
                                break;
                    case "1W" :
                                var currentWeekMonday = new Date().getDate() - new Date().getDay() + 1;
                                let firstDayofWeek = new Date().setDate(currentWeekMonday);
                                let lastDayofWeek = new Date().setDate(currentWeekMonday + 6);
                                let startofThisWeek = new Date(new Date(firstDayofWeek).setHours(0,0,0,0));
                                let endofThisWeek = new Date(new Date(lastDayofWeek).setHours(23,59,59,59));
                                this.setState({startDate:startofThisWeek,endDate:endofThisWeek})
                                break;
                    case "-1W" : 
                                var currentWeekMonday1 = new Date().getDate() - new Date().getDay() + 1;
                                let firstDayOfLastWeek = new Date().setDate(currentWeekMonday1 - 7);
                                let lastDayOfLastWeek =  new Date().setDate(currentWeekMonday1 - 1);
                                let startofLastWeek = new Date(new Date(firstDayOfLastWeek).setHours(0,0,0,0));
                                let endofLastWeek = new Date(new Date(lastDayOfLastWeek).setHours(23,59,59,59));
                                this.setState({startDate:startofLastWeek,endDate:endofLastWeek});
                                break;
                    case "1M" :
                                let firstDayofMonth = new Date(current.getFullYear(), current.getMonth() ,1);
                                let lastDayofMonth = new Date(current.getFullYear(), current.getMonth()+1, 0);
                                let startofThisMonth = new Date(firstDayofMonth.setHours(0,0,0,0));
                                let endofThisMonth = new Date(lastDayofMonth.setHours(23,59,59,59));
                                this.setState({startDate:startofThisMonth,endDate:endofThisMonth});
                                break;
                    case "-1M" :
                                let firstDayofLastMonth = new Date(current.getFullYear(), current.getMonth()-1 ,1);
                                let lastDayofLastMonth = new Date(current.getFullYear(), current.getMonth(), 0);
                                let startofLastMonth = new Date(firstDayofLastMonth.setHours(0,0,0,0));
                                let endofLastMonth = new Date(lastDayofLastMonth.setHours(23,59,59,59));
                                this.setState({startDate:startofLastMonth,endDate:endofLastMonth});
                                break;
                    case "1Y" :
                                let firstDayofYear = new Date(current.getFullYear(), 0 ,1);
                                let lastDayofYear = new Date(current.getFullYear() + 1, 0 ,0);
                                let startofThisYear = new Date(firstDayofYear.setHours(0,0,0,0));
                                let endofThisYear = new Date(lastDayofYear.setHours(23,59,59,59));
                                this.setState({startDate:startofThisYear,endDate:endofThisYear}); 
                                break;
                    case "-1Y" :
                                let firstDayofLastYear = new Date(current.getFullYear()-1,0,1);
                                let lastDayOfLastYear = new Date(current.getFullYear(),0,0);
                                let startofLastYear = new Date(firstDayofLastYear.setHours(0,0,0,0));
                                let endofLastYear = new Date(lastDayOfLastYear.setHours(23,59,59,59));
                                this.setState({startDate:startofLastYear,endDate:endofLastYear});
                                break;
                    case "0D" :
                                this.setState({startDate:new Date(new Date(current).setHours(0, 0, 0, 0)),endDate:new Date(new Date(current).setHours(23, 59, 59, 59))});
                                break;
                    case "C" :
                                let startDate = new Date(new Date(data.startDate.split("T")[0]).setHours(data.startDate.split("T")[1].split(":")[0],data.startDate.split("T")[1].split(":")[1],0));
                                let endDate = new Date(new Date(data.endDate.split("T")[0]).setHours(data.endDate.split("T")[1].split(":")[0],data.endDate.split("T")[1].split(":")[1],0));
                                this.setState({startDate:startDate,endDate:endDate});
                                break;
                    default :   break;
                }
            }     
        }
    }
    
    async setDataToEdit(){
        var buildingId, familyTypeId, equipmentId, datalogId, selectedBuildings = [], selectedFamilyTypes = [], selectedEquipments = [], selectedPoints = [], selectedDatalogs = [], selectedDefId = [];
        if(this.props.DataSource_List_Response !== null && this.props.DataSource_List_Response !== undefined && this.props.DataSource_List_Response.DataSource !== undefined && this.props.DataSource_List_Response.DataSource.length > 0){
            buildingId = Array.from(new Set(this.props.DataSource_List_Response.DataSource.map(el => el.siteId)));
            familyTypeId = Array.from(new Set(this.props.DataSource_List_Response.DataSource.map(el => el.familyId)));
            equipmentId = Array.from(new Set(this.props.DataSource_List_Response.DataSource.map(el => el.equipmentId)));
            datalogId = Array.from(new Set(this.props.DataSource_List_Response.DataSource.map(el => el.datalogDefinitionId)));
            var lineItem = {
                "SiteIds":buildingId,
                "FamilyTypes":familyTypeId
            }

            if(this.props.Buildings_List_Response !== null && this.props.Buildings_List_Response !== undefined && this.props.Buildings_List_Response.Buildings !== undefined && this.props.Buildings_List_Response.Buildings.length > 0){
                buildingId.forEach(el =>{
                    let buildingData = this.props.Buildings_List_Response.Buildings.filter(e => e.siteID === el)[0];
                    if(buildingData !== undefined)
                        selectedBuildings.push({value:buildingData.siteID, label:buildingData.siteName});
                });
            };
            if(this.props.FamilyType_List_Response !== null && this.props.FamilyType_List_Response !== undefined && this.props.FamilyType_List_Response.FamilyTypes !== undefined && this.props.FamilyType_List_Response.FamilyTypes.length > 0){
                familyTypeId.forEach(el =>{
                    let familyTypeData = this.props.FamilyType_List_Response.FamilyTypes.filter(e => Number(e.familyId) === el)[0];
                    if(familyTypeData !== undefined)
                        selectedFamilyTypes.push({value:Number(familyTypeData.familyId), label:familyTypeData.familyName});
                });
            };
            this.setState({SelectedBuildings:selectedBuildings, SelectedFamilyTypes:selectedFamilyTypes});
            
            const equipments = this.props.GetEquipmentList(lineItem); 
            await Promise.all([equipments]);
            if(this.props.Equipment_List_Response !== null && this.props.Equipment_List_Response !== undefined && this.props.Equipment_List_Response.EquipmentList !== undefined && this.props.Equipment_List_Response.EquipmentList.length > 0){
                equipmentId.forEach(el => {
                    let equipmentData = this.props.Equipment_List_Response.EquipmentList.filter(e => e.objectId === el)[0];
                    if(equipmentData !== undefined)
                        selectedEquipments.push({value:equipmentData.objectId,label:equipmentData.siteName + ', '+equipmentData.customObjectName,siteId:equipmentData.siteId,familyId:equipmentData.familyId,name:equipmentData.customObjectName});
                })
            };
            this.setState({SelectedEquipments:selectedEquipments,IsEquipmentLoading:false});

            const points = this.props.GetPointsList(equipmentId,(this.state.startDate).toLocaleString(),(this.state.endDate).toLocaleString());
            await Promise.all([points]);
            if(this.props.Point_List_Response !== null && this.props.Point_List_Response !== undefined && this.props.Point_List_Response.EquipmentPropertiesList !== undefined && this.props.Point_List_Response.EquipmentPropertiesList.length > 0){
                datalogId.forEach(el =>{
                    let pointData = this.props.Point_List_Response.EquipmentPropertiesList.filter(e => e.definitionIds.filter(d => d.definitionId === el)[0])[0];
                    if(pointData !== undefined)
                        selectedPoints.push({value:Number(pointData.id),label:pointData.name,defids: pointData.definitionIds, dataType: pointData.dataType});
                })
                selectedPoints = Array.from(new Set(selectedPoints.map(JSON.stringify))).map(JSON.parse);

                if (selectedPoints.length) {
                    selectedPoints.forEach(e => {
                        if (e.defids.length) {
                            e.defids.map(el => (
                                selectedDefId.push(el.definitionId)
                            ))
                        }
                    })
                }
            };
            this.setState({SelectedPoints:selectedPoints,IsPointLoading:false});

            await this.props.GetDatalogDefinitionList(selectedDefId); 
            if(this.props.Datalogdefinition_List_Response !== null && this.props.Datalogdefinition_List_Response !== undefined && this.props.Datalogdefinition_List_Response.DatalogDefinitions !== undefined && this.props.Datalogdefinition_List_Response.DatalogDefinitions.length > 0){
                datalogId.forEach(el =>{
                    let datalogData = this.props.Datalogdefinition_List_Response.DatalogDefinitions.filter(e => e.datalogDefinitionId === el)[0];
                    let equipID = (selectedPoints.map(e => e.defids.filter(d => d.definitionId === el)[0]).filter(e => e!==undefined)[0] !== undefined) ? selectedPoints.map(e => e.defids.filter(d => d.definitionId === el)[0]).filter(e => e!==undefined)[0].objectId : undefined;
                    let equipment = (equipID !== undefined)? selectedEquipments.filter(e => e.value === equipID)[0] : undefined;
                    if(datalogData !== undefined && equipment !== undefined){
                        let siteName = datalogData.siteName;
                        let equipname = equipment.name;
                        let pointname = selectedPoints.filter(e => e.defids.filter(d => d.definitionId === el))[0].label;
                        let interval = (datalogData.logInterval < 60) ? (datalogData.logInterval === 0) ? "NA" : datalogData.logInterval + " mins" : (datalogData.logInterval / 60) + " hours";
                        let lastsample = (datalogData.displayLastSample !== null) ? new Date(datalogData.displayLastSample).toLocaleDateString() : "";;
                        let attribute = datalogData.attribute;
                        if (selectedBuildings.length > 1)
                            selectedDatalogs.push({ value: datalogData.datalogDefinitionId, label: siteName + ", " + equipname + " " + pointname + " " + interval + " " + lastsample + " " + attribute, equipmentName: siteName + ", " + equipname, pointName: pointname, interval: interval, lastSample: lastsample, attribute: attribute, siteName: siteName, equipmentID: equipID });
                        else
                            selectedDatalogs.push({ value: datalogData.datalogDefinitionId, label: equipname + " " + pointname + " " + interval + " " + lastsample + " " + attribute, equipmentName: equipname, pointName: pointname, interval: interval, lastSample: lastsample, attribute: attribute, siteName: '', equipmentID: equipID });
                    }
                })
            };
            this.setState({SelectedDatalogs:selectedDatalogs,IsDatalogLoading:false});
        }else{ 
            //To handle - In case of all the selected datalogs are deleted from system
            this.setState({IsEquipmentLoading:false,IsPointLoading:false,IsDatalogLoading:false});
        }
    }

    OnNext(tab) {
       this.setState({isDateTimeChanged: false});
       let DatalogDefinitionIds = [];
       this.state.SelectedDatalogs.map(el => (
            DatalogDefinitionIds.push({"DatalogDefinitionId": el.value, "EquipmentId": el.equipmentID})
       ));
       this.props.toggle(tab); 
       this.props.setDatalogDefinitionIds(DatalogDefinitionIds); 
    }

    goBack(tab) {
        this.setState({isDateTimeChanged:this.props.isTimePeriodChanged});
        this.props.toggle(tab);  
    }

    OnCancel(){
        this.setState({redirectBack: true});
    }
  
    filterOptions(options, filter) {
        var selectAllOption = document.querySelectorAll(".options > label")[0];
        if (!filter) {
            if(selectAllOption !== undefined)
                selectAllOption.style.display = "block";
            return options;
        }
        const re = new RegExp(filter, "i");
        var filteredOption = options.filter(({ label }) => label && label.match(re));
        if(selectAllOption !== undefined){
            if(filteredOption.length === 1)
                selectAllOption.style.display = "none";
            else
                selectAllOption.style.display = "block";
        }
        return filteredOption;
    }

    handleRadioPoints(Type){
        this.setState({ PointType: Type });
    }

    createPointsTableHeader(){
        var outerdiv = document.getElementsByClassName("options")[0].children[0];
        /*outer div table*/
        var tablediv = document.createElement("div");
        tablediv.style.display = "table";
        tablediv.style.width = "98%";
        tablediv.style.marginTop = "10px";
        tablediv.style.marginLeft = "10px";
        /*table row*/
        var tablerow = document.createElement("div");
        tablerow.style.display = "table-row";
        /* table cells*/

        var cell0 = document.createElement("div");
        cell0.style.display = "table-cell";
        cell0.style.fontWeight = "700";
        cell0.style.width = "15%";
        cell0.innerText = "Filter Points By:";

        //Analog Start
        var AnalogRadio = document.createElement("input");
        AnalogRadio.setAttribute("type","radio");
        AnalogRadio.setAttribute("name","pointradio");
        AnalogRadio.addEventListener('change', (e) => { 
            this.handleRadioPoints(1);
        });
        AnalogRadio.id = "rdoAnalog";
        AnalogRadio.checked = this.state.PointType === 1 ? true : false;
        AnalogRadio.style.cursor = "pointer";

        var AnalogLbl = document.createElement('label');
        AnalogLbl.setAttribute("for","rdoAnalog");
        AnalogLbl.style.paddingLeft = "1px";
        AnalogLbl.style.cursor = "pointer";
        AnalogLbl.appendChild(document.createTextNode('Analog'));
       
        var cell1 = document.createElement("div");
        cell1.style.display = "table-cell";
        cell1.style.fontWeight = "700";
        cell1.style.width = "85px";
        cell1.appendChild(AnalogRadio);
        cell1.appendChild(AnalogLbl);
        //Analog End
        
        //Binary Start
        var BinaryRadio = document.createElement("input");
        BinaryRadio.setAttribute("type","radio");
        BinaryRadio.setAttribute("name","pointradio");
        BinaryRadio.addEventListener('change', (e) => { 
            this.handleRadioPoints(2);
        });
        BinaryRadio.id = "rdoBinary";
        BinaryRadio.checked = this.state.PointType === 2 ? true : false;
        BinaryRadio.style.cursor = "pointer";

        var BinaryLbl = document.createElement('label');
        BinaryLbl.setAttribute("for","rdoBinary");
        BinaryLbl.style.paddingLeft = "1px";
        BinaryLbl.style.cursor = "pointer";
        BinaryLbl.appendChild(document.createTextNode('Binary'));

        var cell2 = document.createElement("div");
        cell2.style.display = "table-cell";
        cell2.style.fontWeight = "700";
        cell2.style.width = "78px";
        cell2.appendChild(BinaryRadio);
        cell2.appendChild(BinaryLbl);
        //Binary End

        //Multistate Start
        var MultiStatRadio = document.createElement("input");
        MultiStatRadio.setAttribute("type","radio");
        MultiStatRadio.setAttribute("name","pointradio");
        MultiStatRadio.addEventListener('change', (e) => { 
            this.handleRadioPoints(3);
        });
        MultiStatRadio.id = "rdoMultiStat";
        MultiStatRadio.checked = this.state.PointType === 3 ? true : false;
        MultiStatRadio.style.cursor = "pointer";

        var MultiStatLbl = document.createElement('label');
        MultiStatLbl.setAttribute("for","rdoMultiStat");
        MultiStatLbl.style.paddingLeft = "1px";
        MultiStatLbl.style.cursor = "pointer";
        MultiStatLbl.appendChild(document.createTextNode('Multistate'));

        var cell3 = document.createElement("div");
        cell3.style.display = "table-cell";
        cell3.style.fontWeight = "700";
        cell3.style.width = "100px";
        cell3.appendChild(MultiStatRadio);
        cell3.appendChild(MultiStatLbl);
        //Multistate End

        //Select All Start
        var SelectAllRadio = document.createElement("input");
        SelectAllRadio.setAttribute("type","radio");
        SelectAllRadio.setAttribute("name","pointradio");
        SelectAllRadio.addEventListener('change', (e) => { 
            this.handleRadioPoints(0);
        });
        SelectAllRadio.id = "rdoShowAll";
        SelectAllRadio.checked = this.state.PointType === 0 ? true : false;
        SelectAllRadio.style.cursor = "pointer";

        var SelectAllLbl = document.createElement('label');
        SelectAllLbl.setAttribute("for","rdoShowAll");
        SelectAllLbl.style.paddingLeft = "1px";
        SelectAllLbl.style.cursor = "pointer";
        SelectAllLbl.appendChild(document.createTextNode('Show All'));

        var cell4 = document.createElement("div");
        cell4.style.display = "table-cell";
        cell4.style.fontWeight = "700";
        cell4.appendChild(SelectAllRadio);
        cell4.appendChild(SelectAllLbl);
        //Select All End

        /*Append cells to row, row to table, table to outer div*/
        tablerow.append(cell0,cell1,cell2,cell3,cell4);
        tablediv.append(tablerow);
        outerdiv.parentNode.insertBefore(tablediv,outerdiv);
    }

    createTableHeader(){
        var outerdiv = document.getElementsByClassName("options")[0].children[0];
        /*outer div table*/
        var tablediv = document.createElement("div");
        tablediv.style.display = "table";
        tablediv.style.width = "100%";
        tablediv.style.marginTop = "10px";
        /*table row*/
        var tablerow = document.createElement("div");
        tablerow.style.display = "table-row";
        /* table cells*/
        var cell0 = document.createElement("div");
        cell0.style.display = "table-cell";
        cell0.style.paddingLeft = "20px";
        cell0.style.width = "2%";

        var cell1 = document.createElement("div");
        cell1.style.display = "table-cell";
        cell1.style.paddingLeft = "4px";
        cell1.style.fontWeight = "700";
        cell1.style.width = "30%";
        cell1.innerText = "Point";

        var cell2 = document.createElement("div");
        cell2.style.display = "table-cell";
        cell2.style.fontWeight = "700";
        cell2.style.width = "25%";
        cell2.style.paddingLeft = "10px";
        cell2.innerText = "Equipment";

        var cell3 = document.createElement("div");
        cell3.style.display = "table-cell";
        cell3.style.fontWeight = "700";
        cell3.style.width = "10%";
        cell3.innerText = "Interval";

        var cell4 = document.createElement("div");
        cell4.style.display = "table-cell";
        cell4.style.fontWeight = "700";
        cell4.style.width = "15%";
        cell4.innerText = "Last Sample";

        var cell5 = document.createElement("div");
        cell5.style.display = "table-cell";
        cell5.style.fontWeight = "700";
        cell5.style.width = "1%";
        cell5.innerText = "Attribute";
        /*Append cells to row, row to table, table to outer div*/
        tablerow.append(cell0,cell1,cell2,cell3,cell4,cell5);
        tablediv.append(tablerow);
        outerdiv.parentNode.insertBefore(tablediv,outerdiv);
    }
    
    onToggle(args,event){
        if(!event){
            if(!this.state.isToggle){
                if(args === "buildings" || args === "familyTypes"){
                    this.onloadEquipmentData();
                }
                else if(args === "equipment"){
                    this.onloadPointData();
                }
                else if(args === "points"){
                    this.onloadDatalogData();
                }
            }
        }else{
            this.setState({isToggle:true});
            if(args === "datalogs"){
                this.createTableHeader();             
            }
            if(args === "points"){
                this.createPointsTableHeader();
            }
        }
    }

    selectAll = (event,state) => {
        if(document.getElementsByClassName("options")[0] !== undefined){
            if(document.querySelectorAll(".options > label")[0].getElementsByTagName("input")[0].checked === true && document.querySelectorAll(".options > li").length > 1){
                var selectededOptions = Array.prototype.slice.call(document.querySelectorAll(".options > li")).filter(el => el.getElementsByTagName("input")[0].checked === true);
                var unselectedOptions = Array.prototype.slice.call(document.querySelectorAll(".options > li")).filter(el => el.getElementsByTagName("input")[0].checked === false);
                var totalOptions = selectededOptions.length + unselectedOptions.length;
                this.setState(prev => ({
                    [state]: ((selectededOptions.length > unselectedOptions.length) && (totalOptions >= prev[state].length)) ? event : (event.length <= totalOptions && totalOptions!==2)? Array.from(new Set(prev[state].concat(event).map(JSON.stringify))).map(JSON.parse) :(event.length === totalOptions && prev[state].length !==3 ) ? Array.from(new Set(prev[state].concat(event).map(JSON.stringify))).map(JSON.parse) : event
                }))
            }else{
                this.setState({[state]: event});  
            }
        }else{
            this.setState({[state]: event})
        }
    }

    onChangeBuilding(event){
        this.selectAll(event,"SelectedBuildings");
        this.setState({isToggle:false},() => {
            if(!event.length){
                this.onloadEquipmentData();
            }
        });
    }

    onChangeFamilyType(event){
        this.selectAll(event,"SelectedFamilyTypes");
        this.setState({isToggle:false},() => {
            if(!event.length){
                this.onloadEquipmentData();
            }
        });
    }

    onChangeEquipment(event){ 
        this.selectAll(event,"SelectedEquipments");
        this.setState({isToggle:false},() => {
            if(!event.length){
                this.onloadPointData();
            }
        });
    }

    onChangePoint(event){
        this.selectAll(event,"SelectedPoints");
        this.setState({isToggle:false}, () => {
            if(!event.length){
                this.onloadDatalogData();
            }
        });
    }

    onChangeDatalog(event){
        this.selectAll(event,"SelectedDatalogs");
    }

    async onloadEquipmentData(){
        var l_selectedEquipmentId = [], filteredData=[];
        if(!this.state.SelectedBuildings.length){
            this.setState({SelectedFamilyTypes:[],SelectedEquipments:[],SelectedPoints:[],SelectedDatalogs:[]});
        }
        else if(!this.state.SelectedFamilyTypes.length){
            this.setState({SelectedEquipments:[],SelectedPoints:[],SelectedDatalogs:[]});
        }
        else{
            var l_selectedEquipments = this.state.SelectedEquipments;
            var selectedFamilyTypesId = this.state.SelectedFamilyTypes.map(e => e.value); 
            var selectedSiteId = this.state.SelectedBuildings.map(e => e.value);
            var lineItem = {
                "SiteIds":selectedSiteId,
                "FamilyTypes":selectedFamilyTypesId
            }
            this.setState({IsEquipmentLoading:true});
            await (this.props.GetEquipmentList(lineItem));      
            if(l_selectedEquipments.length && l_selectedEquipments !== null && l_selectedEquipments !== undefined ){
                selectedSiteId.forEach(s => {
                    selectedFamilyTypesId.forEach(f => {
                        if(l_selectedEquipments.filter(e => (e.siteId === s && e.familyId === f)).length){
                            var equip = l_selectedEquipments.filter(e => (e.siteId === s && e.familyId === f));
                            filteredData.push.apply(filteredData,equip);
                        }
                    })
                })
                if(filteredData.length){
                    l_selectedEquipmentId = filteredData.map(el => el);
                }
                this.setState({SelectedEquipments: l_selectedEquipmentId, IsPointFetching:true}, () => {this.onloadPointData()})
            }; 
            this.setState({
                SelectedEquipments: l_selectedEquipmentId,
                IsEquipmentLoading: false
            })
        } 
    }

    async onloadPointData(){
        let l_selectedPointId=[],filteredPointData=[];

        if(!this.state.SelectedEquipments.length){
            this.setState({SelectedPoints:[],SelectedDatalogs:[]});
        }
        else{
            var selectedEquipmentId = this.state.SelectedEquipments.map(el => el.value);
            var l_selectedPoints = this.state.SelectedPoints;
            this.setState({IsPointLoading:true});
            await this.props.GetPointsList(selectedEquipmentId,this.props.startDate,this.props.endDate);
            if(l_selectedPoints.length && l_selectedPoints!==undefined && l_selectedPoints!==null){
                if(this.props.Point_List_Response !== null && this.props.Point_List_Response !== undefined && typeof this.props.Point_List_Response.EquipmentPropertiesList !== "string" && this.props.Point_List_Response.EquipmentPropertiesList !== undefined && this.props.Point_List_Response.EquipmentPropertiesList.length){
                    var list = this.props.Point_List_Response.EquipmentPropertiesList.map(value => Number(value.id));
                    list.forEach(e =>{
                        if(l_selectedPoints.filter(p => (p.value === e)).length){
                            var point = l_selectedPoints.filter(p => (p.value === e));
                            filteredPointData.push.apply(filteredPointData,point);
                        }
                    });
                    if(filteredPointData.length){
                        l_selectedPointId = filteredPointData.map(el => el);
                    }
                 this.setState({SelectedPoints:l_selectedPointId, IsDatalogFetching:true},() => {this.onloadDatalogData()});
                }
            }    
            this.setState({
                SelectedPoints: l_selectedPointId,
                IsPointLoading: false,
                IsPointFetching: false
            })
        }
    }

    async onloadDatalogData(){
        let l_selectedDatalogId=[],filteredDatalogData=[],selectedDefId=[];
        if(!this.state.SelectedPoints.length){
            this.setState({SelectedDatalogs:[]});
        }
        else{
            var selectedPointDetails = (this.props.Point_List_Response.EquipmentPropertiesList.length) ? this.props.Point_List_Response.EquipmentPropertiesList.filter(el => this.state.SelectedPoints.some(e => e.value === Number(el.id))) : [];
            if(selectedPointDetails.length){
                selectedPointDetails.forEach(e => {
                    if(e.definitionIds.length){
                        e.definitionIds.map(el => (
                            selectedDefId.push(el.definitionId)
                        )) 
                    }
                })
            }
            //updating the state to have building name if multiple building is selected
            if(this.state.SelectedBuildings.length > 1){
                if(this.props.Datalogdefinition_List_Response !== null && this.props.Datalogdefinition_List_Response !== undefined && this.props.Datalogdefinition_List_Response.DatalogDefinitions.length > 0){
                    if(this.state.SelectedDatalogs.length > 0){
                        this.setState(prevState => ({
                            SelectedDatalogs: prevState.SelectedDatalogs.map(el =>
                                (this.props.Datalogdefinition_List_Response.DatalogDefinitions.filter(e => e.datalogDefinitionId === el.value).length && el.siteName === "") ?
                                    {...el, equipmentName: this.props.Datalogdefinition_List_Response.DatalogDefinitions.filter(e => e.datalogDefinitionId === el.value)[0].siteName+', '+el.equipmentName, label:this.props.Datalogdefinition_List_Response.DatalogDefinitions.filter(e => e.datalogDefinitionId === el.value)[0].siteName+", "+el.equipmentName+" "+el.pointName+" "+el.interval+" "+el.lastSample+" "+el.attribute, siteName:this.props.Datalogdefinition_List_Response.DatalogDefinitions.filter(e => e.datalogDefinitionId === el.value)[0].siteName} : el
                            ),
                        }))
                    }                
                }
            }else{
                if(this.props.Datalogdefinition_List_Response !== null && this.props.Datalogdefinition_List_Response !== undefined && this.props.Datalogdefinition_List_Response.DatalogDefinitions.length > 0){
                    if(this.state.SelectedDatalogs.length > 0){
                        this.setState(prevState => ({
                            SelectedDatalogs: prevState.SelectedDatalogs.map(el =>
                                (this.props.Datalogdefinition_List_Response.DatalogDefinitions.filter(e => e.datalogDefinitionId === el.value).length && el.siteName !== "") ?
                                    {...el, equipmentName: el.equipmentName.split(',')[1], label:el.equipmentName.split(',')[1]+" "+el.pointName+" "+el.interval+" "+el.lastSample+" "+el.attribute, siteName:""} : el
                            ),
                       }))
                    }                
                }
            }  
            this.setState({IsDatalogLoading:true});      
            await this.props.GetDatalogDefinitionList(selectedDefId);
            var l_selectedDatalogs = this.state.SelectedDatalogs; 
            if(l_selectedDatalogs.length && l_selectedDatalogs !== null && l_selectedDatalogs !== undefined){
                selectedDefId.forEach(e => {
                    if(l_selectedDatalogs.filter(p => (p.value === e)).length){
                        var datalog = l_selectedDatalogs.filter(p => (p.value === e));
                        filteredDatalogData.push.apply(filteredDatalogData,datalog);
                    }
                });
                if(filteredDatalogData.length){
                    l_selectedDatalogId = filteredDatalogData.map(el => el);
                } 
            }
            this.setState({
                SelectedDatalogs: l_selectedDatalogId,
                IsDatalogLoading: false,
                IsDatalogFetching: false
            })
        }
    }

    //changes will happen here in the
    itemRender = (options) => {
        return(
                <div style={{display:'table',width:'100%', tableLayout:'fixed', wordWrap:'break-word'}}>
                    {
                        (options.option.label === "Select All") ?
                            <div style={{display:'table-row'}}>
                                <label style={{color: '#007bff'}}> 
                                    <div style={{display:'table-cell',width:'2%'}}><input type="checkbox" onChange={options.onClick} checked={options.checked} style={{marginRight:'8px',verticalAlign:'middle'}}/></div>
                                    <div style={{display:'table-cell'}}>{options.option.label}</div>
                                </label>
                            </div> :
                            <div style={{display:'table-row'}}>
                                <div style={{display:'table-cell',width:'2%'}}><input type="checkbox" onChange={options.onClick} checked={options.checked} style={{verticalAlign:'middle'}}/></div>
                                <div style={{display:'table-cell',width:'30%',paddingLeft:'5px',paddingRight:'15px'}}>{options.option.pointName}</div>
                                <div style={{display:'table-cell',width:'25%',paddingRight:'15px'}}>{options.option.equipmentName}</div>
                                <div style={{display:'table-cell',width:'10%',paddingRight:'15px'}}>{options.option.interval}</div>
                                <div style={{display:'table-cell',width:'15%',paddingRight:'15px'}}>{options.option.lastSample}</div>
                                <div style={{display:'table-cell',width:'6%'}}>{options.option.attribute}</div>
                            </div>
                    }
                </div>
        ) 
    }

    render(){
        var ReportBuildings_in_Select_input=[], 
        ReportFamilyTypes_in_Select_input=[], ReportEquipments_in_Select_input=[], ReportPoints_in_Select_input=[],ReportDatalogs_in_Select_input=[];
        let pointDetails = [];
        let label = this.props.getLabels;
        if(this.state.redirectBack){
           return <Redirect to="/ManageReports/ManageReportsDefinitions"/>         
        }

        /*Buildings*/
        if(this.props.Buildings_List_Response !== null && this.props.Buildings_List_Response !== undefined && this.props.Buildings_List_Response.Buildings !== undefined && this.props.Buildings_List_Response.Buildings.length > 0){
            this.props.Buildings_List_Response.Buildings.sort((a,b) => (a.siteName.toLowerCase() > b.siteName.toLowerCase()) - (a.siteName.toLowerCase() < b.siteName.toLowerCase())).forEach(el =>{
                ReportBuildings_in_Select_input.push({value:el.siteID,label:el.siteName});
            })
        }
       
        /*FamilyTypes*/
        if(this.props.FamilyType_List_Response !== null && this.props.FamilyType_List_Response !== undefined && this.props.FamilyType_List_Response.FamilyTypes !== undefined && this.props.FamilyType_List_Response.FamilyTypes.length > 0){
            this.props.FamilyType_List_Response.FamilyTypes.sort((a,b) => (a.familyName.toLowerCase() > b.familyName.toLowerCase()) - (a.familyName.toLowerCase() < b.familyName.toLowerCase())).forEach(el => {
                ReportFamilyTypes_in_Select_input.push({value:Number(el.familyId),label:el.familyName});
            })
        }
        
        /*Equipments*/
        if(this.props.Equipment_List_Response !== null && this.props.Equipment_List_Response !== undefined && this.props.Equipment_List_Response.EquipmentList !== undefined && this.props.Equipment_List_Response.EquipmentList.length > 0 && !this.state.IsEquipmentLoading){
            Array.from(new Set(this.props.Equipment_List_Response.EquipmentList.map(JSON.stringify))).map(JSON.parse).forEach(el => {
                ReportEquipments_in_Select_input.push({value:el.objectId,label:el.siteName + ', '+el.customObjectName,siteId:el.siteId,familyId:el.familyId,name:el.customObjectName});
            })

            /* Points */
            if(this.props.Point_List_Response !== null && this.props.Point_List_Response !== undefined && typeof this.props.Point_List_Response.EquipmentPropertiesList !== "string" && this.props.Point_List_Response.EquipmentPropertiesList !== undefined && this.props.Point_List_Response.EquipmentPropertiesList.length > 0 && !this.state.IsPointFetching){
                this.props.Point_List_Response.EquipmentPropertiesList.forEach(el => {
                    if(el.definitionIds.length){
                        el.definitionIds.map(e => (
                            pointDetails.push({"value":Number(el.id),"label":el.name,"objectId":e.objectId,"definitionId":e.definitionId})
                        )) 
                    }
                    ReportPoints_in_Select_input.push({value:Number(el.id),label:el.name,defids: el.definitionIds, dataType: el.dataType})
                })
                if(this.state.PointType === 1)
                    ReportPoints_in_Select_input = ReportPoints_in_Select_input.filter( x => x.dataType === "A");
                if(this.state.PointType === 2)
                    ReportPoints_in_Select_input = ReportPoints_in_Select_input.filter( x => x.dataType === "B");
                if(this.state.PointType === 3)
                    ReportPoints_in_Select_input = ReportPoints_in_Select_input.filter( x => x.dataType === "M");
                
            }

            /*Datalogs*/
            if(this.props.Datalogdefinition_List_Response !== null && this.props.Datalogdefinition_List_Response !== undefined && this.props.Datalogdefinition_List_Response.DatalogDefinitions !== undefined && this.props.Datalogdefinition_List_Response.DatalogDefinitions.length > 0 && !this.state.IsDatalogFetching && this.state.SelectedPoints.length > 0){
                pointDetails.forEach(el =>{
                        var data = this.props.Datalogdefinition_List_Response.DatalogDefinitions.filter(e => el.definitionId === e.datalogDefinitionId);
                        var equip = this.props.Equipment_List_Response.EquipmentList.filter(e => e.objectId === el.objectId)[0];
                        if(data.length && equip !== undefined){
                            var equipID = equip.objectId;
                            var equipname = equip.customObjectName;
                            var pointname = el.label;
                            var interval = (data[0].logInterval < 60) ? (data[0].logInterval === 0) ? "NA" : data[0].logInterval + " mins" : (data[0].logInterval/60) + " hours";
                            var lastsample = (data[0].displayLastSample !== null) ? !isNaN(new Date(data[0].displayLastSample).getMinutes()) ? new Date(data[0].displayLastSample).toLocaleDateString() : data[0].displayLastSample : "";
                            var attribute = data[0].attribute;
                            var siteName = data[0].siteName;
                            if(this.state.SelectedBuildings.length > 1){
                                ReportDatalogs_in_Select_input.push({value:data[0].datalogDefinitionId,label:siteName+", "+equipname+" "+pointname+" "+interval+" "+lastsample+" "+attribute,equipmentName:siteName+", "+equipname,pointName:pointname,interval:interval,lastSample:lastsample,attribute:attribute,siteName:siteName,equipmentID:equipID})
                            }
                            else{
                                ReportDatalogs_in_Select_input.push({value:data[0].datalogDefinitionId,label:equipname+" "+pointname+" "+interval+" "+lastsample+" "+attribute,equipmentName:equipname,pointName:pointname,interval:interval,lastSample:lastsample,attribute:attribute,siteName:'',equipmentID:equipID})
                            }
                        }
                    })
                }
        }

        return(
            <div id="DataSource">
                   {/*Header Section*/}
                   <FormGroup row>
                        <DataExportHeader  label={label}/>
                    </FormGroup>
                   <FormGroup row>
                       <Col sm={{size:12}}>
                            <Label className="dataexportheaderlbl">{label['DataExport.lblDataSourceHeader.Text'] !== undefined ? label['DataExport.lblDataSourceHeader.Text'] : "Data Sources - Buildings and Equipment"}</Label>
                       </Col>
                   </FormGroup>
                   <hr/>
                   {/*Warning Message*/}
                   <FormGroup row style={(this.state.isDateTimeChanged)? displayUnHidden : displayHidden}>
                       <Col sm={{size:12}}>
                            <Icon name='exclamation triangle' style={{'color': '#BE5104','padding-right': '20px', 'padding-top': '0px'}} />
                            <Label className="workorderheaderlbl" style={{display:'inline',color:'#BE5104',fontWeight:'bold'}}>You have changed the Time Period. Please review the data logs selected below to ensure they have been collected during the Time Period you selected.</Label>
                       </Col>
                   </FormGroup>
                    {/*Building Dropdown*/}
                    <FormGroup row>
                        <Col sm={{size:12}}>
                            <Label id="label_reportbuilding" style={{ marginBottom: "0px" }} className="workorderlbl">{label['DataExport.lblBuilding.Text'] !== undefined ? label['DataExport.lblBuilding.Text'] : "Building"}</Label><br/>
                            <div id="select_reportbuilding" style={{display:'inline'}}>
                                <MultiSelect
                                    labelledBy="Select"
                                    options={ReportBuildings_in_Select_input}
                                    onChange={this.onChangeBuilding.bind(this)}
                                    value={this.state.SelectedBuildings}
                                    onMenuToggle={this.onToggle.bind(this,"buildings")}
                                    filterOptions={this.filterOptions.bind(this)}
                                    disabled={this.state.IsBuildingLoading}
                                />
                            </div>
                            <img src={LoadProgressIndicator} alt="loadingprogress" style={{"padding-left":"10px","display":this.state.IsBuildingLoading?"initial":"none"}} />
                        </Col>
                    </FormGroup>

                    {/*Family Type Dropdown*/}
                    <FormGroup row>
                        <Col sm={{size:12}}>
                            <Label id="label_reportfamilytype" style={{ marginBottom: "0px" }} className="workorderlbl">{label['DataExport.lblFamilyType.Text'] !== undefined ? label['DataExport.lblFamilyType.Text'] : "Family Type"}</Label><br/>
                            <div id="select_reportfamilytype" style={{display:'inline'}}>
                                <MultiSelect
                                    labelledBy="Select"
                                    options={ReportFamilyTypes_in_Select_input}
                                    onChange={this.onChangeFamilyType.bind(this)}
                                    value={this.state.SelectedFamilyTypes}
                                    filterOptions={this.filterOptions.bind(this)}
                                    onMenuToggle={this.onToggle.bind(this,"familyTypes")}
                                    disabled={(this.state.SelectedBuildings.length && !this.state.IsFamilyTypeLoading) ? false : true}
                                    className={(this.state.SelectedBuildings.length && !this.state.IsFamilyTypeLoading) ? "" : "disable-multi-select"}
                                />
                                <img src={LoadProgressIndicator} alt="loadingprogress" style={{"padding-left":"10px","display":this.state.IsFamilyTypeLoading?"initial":"none"}} />
                           </div>
                        </Col>
                    </FormGroup>

                    {/*Equipment Dropdown*/}
                    <FormGroup row>
                        <Col sm={{size:12}}>
                            <Label id="label_reportequipment" style={{ marginBottom: "0px" }} className="workorderlbl">{label['DataExport.lblEquipment.Text'] !== undefined ? label['DataExport.lblEquipment.Text'] : "Equipment"}</Label><br/>
                            <div id="select_reportequipment" style={{display:'inline'}}>
                                <MultiSelect
                                    labelledBy="Select"
                                    options={ReportEquipments_in_Select_input}
                                    onChange={this.onChangeEquipment.bind(this)}
                                    value={this.state.SelectedEquipments}
                                    onMenuToggle={this.onToggle.bind(this,"equipment")}
                                    filterOptions={this.filterOptions.bind(this)}
                                    disabled={(this.state.SelectedFamilyTypes.length && !this.state.IsEquipmentLoading) ? false : true}
                                    className={(this.state.SelectedFamilyTypes.length && !this.state.IsEquipmentLoading) ? "" : "disable-multi-select"}
                                />
                            </div>
                            <img src={LoadProgressIndicator} alt="loadingprogress" style={{"padding-left":"10px","display":this.state.IsEquipmentLoading?"initial":"none"}} />
                        </Col>
                    </FormGroup>

                    {/*Points*/}
                     <FormGroup row>
                        <Col sm={{size:12}}>
                            <Label id="label_reportpoints" style={{ marginBottom: "0px" }} className="workorderlbl">{label['DataExport.lblPoint.Text'] !== undefined ? label['DataExport.lblPoint.Text'] : "Point"}</Label><br/>
                            <div id="select_reportpoints" style={{display:'inline'}}>
                                <MultiSelect
                                    labelledBy="Select"
                                    options={ReportPoints_in_Select_input}
                                    onChange={this.onChangePoint.bind(this)}
                                    value={this.state.SelectedPoints}
                                    filterOptions={this.filterOptions.bind(this)}
                                    onMenuToggle={this.onToggle.bind(this,"points")}
                                    disabled={(this.state.SelectedEquipments.length && !this.state.IsPointLoading) ? false : true}
                                    className={(this.state.SelectedEquipments.length && !this.state.IsPointLoading) ? "" : "disable-multi-select"}
                                />
                            </div>
                            <img src={LoadProgressIndicator} alt="loadingprogress" style={{"padding-left":"10px","display":this.state.IsPointLoading?"initial":"none"}} />
                        </Col>
                    </FormGroup>

                    {/* datalog */}
                     <FormGroup row>
                        <Col sm={{size:12}}>
                            <Label id="label_reportdatalog" style={{ marginBottom: "0px" }} className="workorderlbl">{label['DataExport.lblDataLog.Text'] !== undefined ? label['DataExport.lblDataLog.Text'] : "Data Log"}</Label><br/>
                            <div id="select_reportdatalog" style={{display:'inline'}}>
                                 <MultiSelect
                                    labelledBy="Select"
                                    options={ReportDatalogs_in_Select_input}
                                    onChange={this.onChangeDatalog.bind(this)}
                                    ItemRenderer={this.itemRender.bind(this)}
                                    value={this.state.SelectedDatalogs}
                                    filterOptions={this.filterOptions.bind(this)}
                                    onMenuToggle={this.onToggle.bind(this,"datalogs")}
                                    disabled={(this.state.SelectedPoints.length && !this.state.IsDatalogLoading) ? false : true}
                                    className={(this.state.SelectedPoints.length && !this.state.IsDatalogLoading) ? "" : "disable-multi-select"}
                                />
                            </div>
                            <img src={LoadProgressIndicator} alt="loadingprogress" style={{"padding-left":"10px","display":this.state.IsDatalogLoading?"initial":"none"}} />
                            <br/>
                            <Label id="label_reportnote" style={{ marginBottom: "0px","padding-top": "4px" }} className="workorderlbl">{label['DataExport.lblDataSourceNote.Text'] !== undefined ? label['DataExport.lblDataSourceNote.Text'] : "Note: Only stored datalogs per the selected time period will be exported"}</Label><br/>
                        </Col>
                    </FormGroup>
                   
                    {/*Button*/}
                    <FormGroup row className="report_buttons">
                        <Col sm={{ size: 12 }}>
                            <hr/>
                            <Label style={{position:'absolute', marginBottom:'0px', bottom:'0' }} className="link-cursor-underline" onClick={this.OnCancel}>{label['ReportManagement.btncancel.Text'] !== undefined ? label['ReportManagement.btncancel.Text'] : "Cancel"}</Label>
                            <Button style={{float:'right', marginRight:'0px'}} className="btn-success btn-md"  onClick={() => { this.OnNext('3'); }} disabled={this.state.SelectedDatalogs.length > 0 ? false:true}>{label['ReportViewer.FindNextButtonText.Text'] !== undefined ? label['ReportViewer.FindNextButtonText.Text'] : "Next"}</Button>
                            <Button  style={{float:'right', marginLeft:'0px'}} className="btn-gray btn-md" onClick={() => { this.goBack('1'); }}>{label['ReportManagement.btnback.Text'] !== undefined ? label['ReportManagement.btnback.Text'] : "Back"}</Button>
                        </Col>
                    </FormGroup>
            </div>
        )
    }
};

const mapStateToProps = state => {
    return{
        getLabels: state.CulturalLabelsRootReducer.ReportMgmt_LabelsBasedOnPreference,
        Buildings_List_Response: state.DataExportBuildingReducer,
        FamilyType_List_Response: state.DataExportFamilyTypeReducer,
        Equipment_List_Response: state.DataExportEquipmentListReducer,
        Point_List_Response: state.DataExportEquipmentPropertiesReducer,
        Datalogdefinition_List_Response: state.DataExportDatalogDefinitionsReducer,
        DataSource_List_Response: state.DataExportDataSourceReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return{
        GetBuildingsList: () => dispatch(getAllBuildingsList()),
        GetAllFamilyTypesList: () => dispatch(getAllFamilyTypesList()),
        GetEquipmentList: (data) => dispatch(getEquipmentList(data)),
        GetPointsList: (data,startDate,endDate) => dispatch(getEquipmentPropertiesList(data,startDate,endDate)),
        GetDatalogDefinitionList: (data) => dispatch(getDatalogDefinitionsList(data)),
        GetDataSourceDetails: (reportID) => dispatch(getDataSourceDetails(reportID)),
    };
};

export default connect(mapStateToProps,mapDispatchToProps) (SelectDataSources);
